import { render, staticRenderFns } from "./NewLeaveRequestPlain.vue?vue&type=template&id=291cac91&scoped=true&"
import script from "./NewLeaveRequestPlain.vue?vue&type=script&lang=js&"
export * from "./NewLeaveRequestPlain.vue?vue&type=script&lang=js&"
import style0 from "./NewLeaveRequestPlain.vue?vue&type=style&index=0&id=291cac91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291cac91",
  null
  
)

export default component.exports